var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 110,
    viewBox: "0 0 123 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5916 101.066L51.6331 105.322V99.7566L52.9426 98.4471H62.1091V104.995V109.578H52.2879L40.1748 104.34L35.5916 101.066Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9714 101.066L72.2575 105.322V99.7566L70.948 98.4471H61.7816V104.995V109.578H71.6028L83.7153 104.34L87.9714 101.066Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9428 88.9536L51.6333 99.7566L53.2699 98.4471H70.2933L72.2575 99.7566L70.948 88.9536L68.329 87.3164L55.2341 87.6441L52.9428 88.9536Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1033 15.9491L51.9602 34.282L55.5616 87.6441H68.3289L72.2574 34.282L79.4596 15.9491H44.1033Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72944 56.2162L0.562988 82.7332L23.4791 81.4237H38.2106V69.9659L37.5559 46.395L34.2821 49.014L9.72944 56.2162Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0798 59.1624L53.9244 59.8171L50.9784 73.5668L38.2105 70.293L27.0798 59.1624Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0798 59.49L38.2105 69.9659V80.4419L27.0798 59.49Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2107 70.293L51.3056 73.5667L55.5618 87.644L52.6151 89.2806L38.2107 80.7689V70.293Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2105 80.7689L35.5916 101.066L52.9426 88.9535L38.2105 80.7689Z",
    fill: "#EB8F35"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9246 59.817L55.5618 87.644L50.6509 73.4032L53.9246 59.817Z",
    fill: "#EA8E3A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1514 81.0966L38.2105 80.7689L35.5916 101.066L23.1514 81.0966Z",
    fill: "#D87C30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7652 109.905L35.5916 101.066L23.1515 81.0966L0.562988 82.7331L7.7652 109.905Z",
    fill: "#EB8F35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9602 34.282L37.8834 46.0674L27.0798 59.1623L53.9244 60.1448L51.9602 34.282Z",
    fill: "#E8821E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5916 101.066L52.9426 88.9536L51.6331 99.4296V105.322L39.8477 103.03L35.5916 101.066Z",
    fill: "#DFCEC3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9714 101.066L70.948 88.9536L72.2575 99.4296V105.322L84.043 103.03L87.9714 101.066Z",
    fill: "#DFCEC3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7223 65.7097L50.3237 73.2396L37.5559 69.9659L46.7223 65.7097Z",
    fill: "#393939"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4375 0.562744L51.9603 34.2819L44.431 15.949L7.4375 0.562744Z",
    fill: "#E88F35"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43764 0.5625L1.54492 18.568L4.81865 38.2104L2.52704 39.5199L5.80077 42.4663L3.18179 44.7579L6.78289 48.0316L4.49128 49.9959L9.72925 56.5433L34.2822 49.0137C46.2859 39.4108 52.1787 34.5002 51.9604 34.2819C51.7422 34.0637 36.9012 22.8239 7.43764 0.5625Z",
    fill: "#8E5A30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.834 56.2162L123 82.7332L100.084 81.4237H85.3524V69.9659L86.0071 46.395L89.2808 49.014L113.834 56.2162Z",
    fill: "#F89D35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4832 59.1624L69.6385 59.8171L72.5846 73.5668L85.3525 70.293L96.4832 59.1624Z",
    fill: "#D87C30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4832 59.49L85.3525 69.9659V80.4419L96.4832 59.49Z",
    fill: "#EA8D3A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3523 70.293L72.2574 73.5667L68.0012 87.644L70.9479 89.2806L85.3523 80.7689V70.293Z",
    fill: "#F89D35"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3524 80.7689L87.9714 101.066L70.948 89.2806L85.3524 80.7689Z",
    fill: "#EB8F35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6384 59.817L68.0012 87.644L72.9121 73.4032L69.6384 59.817Z",
    fill: "#EA8E3A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.412 81.0966L85.3525 80.7689L87.9714 101.066L100.412 81.0966Z",
    fill: "#D87C30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.798 109.905L87.9714 101.066L100.412 81.0966L123 82.7331L115.798 109.905Z",
    fill: "#EB8F35"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6028 34.282L85.6795 46.0674L96.4832 59.1623L69.6385 60.1448L71.6028 34.282Z",
    fill: "#E8821E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8407 65.7097L73.2393 73.2396L86.0071 69.9659L76.8407 65.7097Z",
    fill: "#393939"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.125 0.562744L71.6027 34.2819L79.132 15.949L116.125 0.562744Z",
    fill: "#E88F35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.125 0.5625L122.018 18.568L118.744 38.2104L121.036 39.5199L117.762 42.4663L120.381 44.7579L116.78 48.0316L119.072 49.9959L113.834 56.5433L89.2807 49.0137C77.2771 39.4108 71.3843 34.5002 71.6026 34.2819C71.8208 34.0637 86.6618 22.8239 116.125 0.5625Z",
    fill: "#8E5A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.af41c76658d6fcb31ee28a881be2255c.svg";
export { ForwardRef as ReactComponent };